import { render, staticRenderFns } from "./OFirstPartDataProductComp.vue?vue&type=template&id=5f9bca17&"
import script from "./OFirstPartDataProductComp.vue?vue&type=script&lang=js&"
export * from "./OFirstPartDataProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports